/* Personalised Lolly Bags V2
   Canopy handles variants and cart submission.
   Globo handles custom options, validation and add-ons.
*/

(() => {
  'use strict';

  if (window.LollyStandardV2) {
    window.LollyStandardV2.init(document);
    return;
  }

  const normalise = value => String(value || '')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase();

  const choiceName = input => (
    input.getAttribute('original-value') ||
    input.value ||
    ''
  ).trim();

  function contentsDescription(value) {
    let text = String(value || '')
      .replace(/^\s*[\d,]+\s*bags?\b/i, '')
      .replace(/^[\s,;:–—-]+/, '')
      .trim();

    if (text.startsWith('(') && text.endsWith(')')) {
      text = text.slice(1, -1).trim();
    }

    text = text
      .replace(/^approx(?:imately)?\.?\s*/i, 'Approx ')
      .replace(/\s+(?:ea\.?|each)\s*\.?$/i, ' per bag')
      .replace(/\.\s*$/, '')
      .trim();

    if (text && !/\bper\s+bag\b/i.test(text)) {
      text += ' per bag';
    }

    return text
      ? text.charAt(0).toUpperCase() + text.slice(1)
      : '';
  }

function prepareQuantity(container, previousContainer = null) {
  function describe(value) {
    const original = String(value || '').trim();

    const bags = original.match(
      /^\s*([\d,]+)\s*bags?\b/i
    );

    if (bags) {
      const count = Number(bags[1].replaceAll(',', ''));

      return {
        type: 'bags',
        heading: 'Choose your bag quantity',
        label: `${count.toLocaleString('en-NZ')} bags`,
        note: contentsDescription(original)
      };
    }

    const lollipops = original.match(
      /^lollipops?\s+(\d+(?:\.\d+)?)\s*g\s*,?\s*approx(?:imately)?\.?\s*([\d,]+)\s*$/i
    );

    if (lollipops) {
      const count = Number(lollipops[2].replaceAll(',', ''));

      return {
        type: 'lollipops',
        heading: 'Choose your lollipop quantity',
        label: `Approx. ${count.toLocaleString('en-NZ')} lollipops`,
        note: `${lollipops[1]}g per lollipop`
      };
    }

    return null;
  }

  container.querySelectorAll('.option-selector').forEach(field => {
    const inputs = Array.from(
      field.querySelectorAll('input[type="radio"]')
    );

    if (!inputs.length) return;

    const descriptions = inputs.map(input => describe(input.value));

    if (
      descriptions.some(description => !description) ||
      !descriptions.every(description =>
        description.type === descriptions[0].type
      )
    ) {
      return;
    }

    const legend = field.querySelector('legend');
    const heading = descriptions[0].heading;

    if (legend && legend.textContent !== heading) {
      legend.textContent = heading;
    }

    const buttons = field.querySelector('.option-selector__btns');
    if (!buttons) return;

    let currentValue = null;

    if (previousContainer) {
      const previousField = Array.from(
        previousContainer.querySelectorAll('.option-selector')
      ).find(previous =>
        previous.dataset.index === field.dataset.index
      );

      currentValue = previousField
        ?.querySelector('input[type="radio"]:checked')
        ?.value;
    }

    const selected =
      inputs.find(input => input.value === currentValue) ||
      inputs.find(input => input.checked) ||
      inputs[0];

    const selectedDescription = describe(selected.value);

    let note = field.querySelector('.lolly-pack-note');

    if (!note) {
      note = document.createElement('p');
      note.className = 'lolly-pack-note';
      buttons.before(note);
    }

    if (note.textContent !== selectedDescription.note) {
      note.textContent = selectedDescription.note;
    }

    if (note.hidden !== !selectedDescription.note) {
      note.hidden = !selectedDescription.note;
    }

    const labels = Array.from(field.querySelectorAll('label'));

    inputs.forEach((input, index) => {
      const label = labels.find(item => item.htmlFor === input.id);
      const text = label?.querySelector('span');
      const description = descriptions[index];

      if (text && text.textContent !== description.label) {
        text.textContent = description.label;
      }
    });
  });
}

  const appSelector =
    '.gpo-app, .gpo-container, .gpo-product-variants';

  class StandardBags {
    constructor(root) {
      this.root = root;
      this.destroyed = false;
      this.pending = false;
      this.updateTimer = null;
      this.retryTimers = [];
      this.termsDirty = true;

      try {
        this.data = JSON.parse(
          root.querySelector('[data-lolly-data]').textContent
        );
      } catch (_) {
        this.status(
          'The order summary could not load. Please refresh the page.'
        );
        return;
      }

      this.variants = Array.isArray(this.data.variants)
        ? this.data.variants
        : [];

      this.labels = new Map(
        (Array.isArray(this.data.labels) ? this.data.labels : [])
          .map(variant => [
            String(variant.id),
            Number(variant.price)
          ])
      );

      this.names = new Set([
        this.data.unlabelled,
        this.data.supplied,
        this.data.applied
      ].map(normalise).filter(Boolean));

      this.money = new Intl.NumberFormat('en-NZ', {
        style: 'currency',
        currency: this.data.currency || 'NZD'
      });

      this.onChange = this.onChange.bind(this);
      this.onInput = this.onInput.bind(this);
      this.onVariant = this.onVariant.bind(this);
      this.onRendered = this.onRendered.bind(this);
      this.guardPurchase = this.guardPurchase.bind(this);

      root.addEventListener('change', this.onChange, true);
      root.addEventListener('input', this.onInput);
      root.addEventListener('on:variant:change', this.onVariant);
      root.addEventListener('submit', this.guardPurchase, true);
      root.addEventListener('click', this.guardPurchase, true);

      document.addEventListener(
        'gpoRenderCompleted',
        this.onRendered
      );

      this.appObserver = new MutationObserver(records => {
        if (records.some(record => record.type === 'childList')) {
          this.termsDirty = true;
        }

        this.schedule();
      });

      this.findApp();

      if (!this.app) {
        this.mountObserver = new MutationObserver(() => {
          if (this.findApp()) {
            this.mountObserver.disconnect();
            this.schedule();
          }
        });

        this.mountObserver.observe(root, {
          childList: true,
          subtree: true
        });
      }

      prepareQuantity(root);
      this.update();
    }

    put(selector, text) {
      const element = this.root.querySelector(selector);

      if (element && element.textContent !== text) {
        element.textContent = text;
      }
    }

    status(text) {
      this.put('[data-lolly-status]', text);
    }

    price(cents) {
      return this.money.format(cents / 100);
    }

    form() {
      return this.root.querySelector('.js-product-form-main');
    }

    findApp() {
      const app = this.root.querySelector(appSelector);

      if (!app || app === this.app) {
        return Boolean(app);
      }

      this.appObserver.disconnect();
      this.app = app;
      this.termsDirty = true;

      this.appObserver.observe(app, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: [
          'class',
          'style',
          'hidden',
          'disabled',
          'checked',
          'value',
          'data-clo-display',
          'data-addon-price',
          'gpo-data-variant-id'
        ]
      });

      return true;
    }

    selectedVariant() {
      const fields = Array.from(
        this.root.querySelectorAll(
          '.product-options ' +
          '.option-selector:not(.option-selector--custom)'
        )
      );

      if (fields.length) {
        const values = fields.map(field => {
          const radio = field.querySelector(
            'input[type="radio"]:checked'
          );

          if (radio) return radio.value;

          return field.querySelector(
            '.custom-select__option[aria-selected="true"]'
          )?.dataset.value || null;
        });

        if (values.some(value => value === null)) return null;

        return this.variants.find(variant =>
          variant.options?.length === values.length &&
          variant.options.every(
            (value, index) => value === values[index]
          )
        ) || null;
      }

      const id = this.form()?.querySelector('[name="id"]')?.value;

      return this.variants.find(
        variant => String(variant.id) === String(id)
      ) || null;
    }

    formMatches(variant) {
      const id = this.form()?.querySelector('[name="id"]')?.value;

      return Boolean(
        variant && String(id) === String(variant.id)
      );
    }

    visible(input) {
      if (input.disabled) return false;

      const field = input.closest('.gpo-element');

      if (!field || !field.getClientRects().length) {
        return false;
      }

      let element = input.parentElement;

      while (element && element !== this.root) {
        if (element.hidden) return false;

        const style = getComputedStyle(element);

        if (
          style.display === 'none' ||
          style.visibility === 'hidden'
        ) {
          return false;
        }

        element = element.parentElement;
      }

      return true;
    }

    labelPrice(input) {
      if (
        normalise(choiceName(input)) ===
        normalise(this.data.unlabelled)
      ) {
        return 0;
      }

      const addon = input.getAttribute('data-addon-price');

      if (addon !== null && addon.trim() !== '') {
        const amount = Number(addon);

        if (Number.isFinite(amount) && amount >= 0) {
          return Math.round(amount * 100);
        }
      }

      const id = input.getAttribute('gpo-data-variant-id');
      const amount = id ? this.labels.get(String(id)) : undefined;

      return Number.isFinite(amount) && amount >= 0
        ? amount
        : null;
    }

    styleTerms() {
      if (!this.termsDirty) return;
      this.termsDirty = false;

      const targets = [
        [this.data.termsField, 'lolly-terms-field'],
        [this.data.termsLink, 'lolly-terms-link']
      ];

      targets.forEach(([id, className]) => {
        if (!id) return;

        const field = this.root.querySelector(
          `.gpo-element[data-element-id="${CSS.escape(id)}"]`
        );

        if (field && !field.classList.contains(className)) {
          field.classList.add(className);
        }
      });
    }

    update() {
      if (this.destroyed || !this.root.isConnected) return;

      this.styleTerms();

      const variant = this.selectedVariant();
      const quantity = Math.max(
        1,
        Math.floor(Number(
          this.form()?.querySelector('[name="quantity"]')?.value || 1
        )) || 1
      );

      if (!variant) {
        this.put('[data-pack]', 'Selected bags');
        this.put('[data-bags-price]', '—');
        this.clearFinish();
        this.status('Choose an available bag quantity.');
        return;
      }

      /*
       * Read the selected finish before writing summary content,
       * avoiding interleaved layout reads and summary changes.
       */
      let finish = null;
      let finishHelp = '';
      let surcharge = null;

      if (
        !this.pending &&
        this.formMatches(variant) &&
        variant.available
      ) {
        finish = Array.from(this.root.querySelectorAll(
          '.gpo-radio input[type="radio"]:checked'
        )).find(input =>
          this.names.has(normalise(choiceName(input))) &&
          this.visible(input)
        );

        if (finish) {
          finishHelp = finish.closest('.gpo-radio')
            ?.querySelector('.gpo-ov-helptext')
            ?.textContent.trim() || '';

          surcharge = this.labelPrice(finish);
        }
      }

      this.put(
        '[data-pack]',
        variant.title +
        (quantity > 1 ? ` × ${quantity} packs` : '')
      );

      this.put(
        '[data-bags-price]',
        this.price(Number(variant.price) * quantity)
      );

      if (this.pending || !this.formMatches(variant)) {
        this.clearFinish();
        this.status('');
        return;
      }

      if (!variant.available) {
        this.clearFinish();
        this.status('This bag quantity is currently unavailable.');
        return;
      }

      this.status('');

      if (!finish) {
        this.clearFinish();
        return;
      }

      this.put('[data-finish]', choiceName(finish));
      this.put('[data-finish-help]', finishHelp);

      if (surcharge === null) {
        this.put('[data-label-price]', 'Price unavailable');
        this.put('[data-total]', '—');
        this.status('Please reselect your label option.');
        return;
      }

      this.put(
        '[data-label-price]',
        this.price(surcharge * quantity)
      );

      this.put(
        '[data-total]',
        this.price(
          (Number(variant.price) + surcharge) * quantity
        )
      );
    }

    clearFinish() {
      this.put('[data-finish]', 'Choose your label option');
      this.put('[data-finish-help]', '');
      this.put('[data-label-price]', '—');
      this.put('[data-total]', '—');
    }

    schedule() {
      if (this.destroyed || this.updateTimer !== null) return;

      /*
       * Batch Globo's startup mutations.
       * Further mutations do not restart this timer.
       */
      this.updateTimer = setTimeout(() => {
        this.updateTimer = null;
        this.update();
      }, 50);
    }

    recheck() {
      this.retryTimers.forEach(clearTimeout);

      this.retryTimers = [150, 500, 1000].map(delay =>
        setTimeout(() => this.schedule(), delay)
      );

      this.schedule();
    }

    onRendered() {
      if (this.destroyed || !this.root.isConnected) return;

      this.findApp();
      this.termsDirty = true;
      this.recheck();
    }

    onChange(event) {
      if (!(event.target instanceof Element)) return;

      if (event.target.closest('variant-picker')) {
        prepareQuantity(this.root);
        this.pending = true;

        clearTimeout(this.variantTimeout);

        this.variantTimeout = setTimeout(() => {
          if (!this.pending || this.destroyed) return;

          const variant = this.selectedVariant();
          let fetched = null;

          try {
            fetched = JSON.parse(
              this.root.querySelector(
                'variant-picker script[type="application/json"]'
              )?.textContent || 'null'
            );
          } catch (_) {
            // Retain the pending state.
          }

          if (
            fetched &&
            String(fetched.id) === String(variant?.id) &&
            this.formMatches(variant)
          ) {
            this.pending = false;
            this.recheck();
          } else {
            this.status(
              'The bag options could not finish updating. ' +
              'Please refresh and try again.'
            );
          }
        }, 8000);

        this.update();
        return;
      }

      if (
        event.target.closest(appSelector) ||
        event.target.matches('[name="quantity"], [name="id"]')
      ) {
        this.recheck();
      }
    }

    onInput(event) {
      if (
        event.target instanceof Element &&
        event.target.matches('[name="quantity"]')
      ) {
        this.schedule();
      }
    }

    onVariant(event) {
      if (!this.root.contains(event.target)) return;

      clearTimeout(this.variantTimeout);
      this.pending = false;

      prepareQuantity(this.root);
      this.findApp();
      this.recheck();
    }

    guardPurchase(event) {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const purchase = event.type === 'submit'
        ? target.matches('.js-product-form-main')
        : Boolean(target.closest(
          '.js-product-form-main [name="add"]'
        ));

      if (!purchase) return;

      const variant = this.selectedVariant();

      if (this.pending || !this.formMatches(variant)) {
        event.preventDefault();
        event.stopImmediatePropagation();

        this.status(
          'Please wait for the bag options to finish updating.'
        );
      }
    }

    destroy() {
      this.destroyed = true;

      this.appObserver?.disconnect();
      this.mountObserver?.disconnect();

      clearTimeout(this.updateTimer);
      clearTimeout(this.variantTimeout);
      this.retryTimers.forEach(clearTimeout);

      this.root.removeEventListener('change', this.onChange, true);
      this.root.removeEventListener('input', this.onInput);
      this.root.removeEventListener(
        'on:variant:change',
        this.onVariant
      );
      this.root.removeEventListener(
        'submit',
        this.guardPurchase,
        true
      );
      this.root.removeEventListener(
        'click',
        this.guardPurchase,
        true
      );

      document.removeEventListener(
        'gpoRenderCompleted',
        this.onRendered
      );
    }
  }

  const instances = new Map();

  function init(container) {
    const roots = Array.from(
      container.querySelectorAll('[data-lolly-standard]')
    );

    if (container.matches?.('[data-lolly-standard]')) {
      roots.unshift(container);
    }

    roots.forEach(root => {
      if (
        root.querySelector('[data-lolly-data]') &&
        !instances.has(root)
      ) {
        instances.set(root, new StandardBags(root));
      }
    });
  }

  /*
   * Preserve the quantity heading and contents note before
   * Canopy inserts refreshed markup.
   */
  document.addEventListener(
    'on:variant:before-replace-element',
    event => {
      const { toReplace, replaceWith } = event.detail || {};

      if (
        !toReplace ||
        !replaceWith ||
        !toReplace.closest('[data-lolly-standard]') ||
        !toReplace.matches('.product-options')
      ) {
        return;
      }

      prepareQuantity(replaceWith, toReplace);
    }
  );

  window.LollyStandardV2 = { init };

  document.addEventListener(
    'shopify:section:load',
    event => init(event.target)
  );

  document.addEventListener(
    'shopify:section:unload',
    event => {
      instances.forEach((instance, root) => {
        if (event.target.contains(root)) {
          instance.destroy();
          instances.delete(root);
        }
      });
    }
  );

  init(document);
})();